import { render, staticRenderFns } from "./SupportModalComponent.vue?vue&type=template&id=0b549578&scoped=true&"
import script from "./SupportModalComponent.vue?vue&type=script&lang=js&"
export * from "./SupportModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./SupportModalComponent.vue?vue&type=style&index=0&id=0b549578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b549578",
  null
  
)

export default component.exports